import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionTipoTurnoService {

  diccionarioModulo: any;
  url: string;

  constructor(private http: HttpClient, private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }


  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.tipoTurno.getAll);
  }

  update(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.tipoTurno.update + payload.id, payload);
  }

  delete(payload) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.tipoTurno.delete + payload.id);
  }

  createTipoTurno(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.tipoTurno.create, payload);
  }
}
